export default "__VITE_ASSET__C19uUy87__"